import { createFileRoute } from '@tanstack/react-router';

import { SecurityPage, twoFactorStatusQueryOptions } from '@/features/auth';

/** Every platform role manages its own two-factor. */
export const Route = createFileRoute('/_authed/account/security')({
  staticData: { crumbKey: 'nav.security', tours: ['platform.security'] },
  loader: ({ context }) =>
    context.queryClient
      .query({ ...twoFactorStatusQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: SecurityPage,
});
